import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Typography, Box } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

const POD = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  // ---------- State ----------
  const [SignatureDate, setSignatureDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [Signature, setSignature] = useState(props.PatientName);
  const [PrintName, setPrintName] = useState("");
  const [BrandName, setBrandName] = useState("");
  const [OtherItem, setOtherItem] = useState("");
  const [Qunatity, setQunatity] = useState("");
  const [OtherItemChecked, setOtherItemChecked] = useState(false);

  const FormId = props.FormId;

  // ---------- Load existing form (agar edit ho raha ho) ----------
  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetPODId?id=${FormId}`,
          { headers },
        )
        .then((response) => {
          setSignatureDate(
            response.date
              ? moment(response.date).format("YYYY-MM-DD")
              : "",
          );
          setSignature(response.patientName || "");
          setPrintName(response.patientName || "");
          setBrandName(response.brandName)
          setOtherItem(response.otherItem)
          setOtherItem(response.otherItem)
          setQunatity(response.quantity)
        })
        .catch((error) => {});
    }
  }, [FormId]);

  // ---------- Submit ----------
  const handleSubmit = async () => {
    const postData = {
      id: props.FormId,
      patientName: PrintName || props.PatientName,
      patientId: props.PatientId,
      patientSignature: Signature,
      date: SignatureDate,
      brandName: BrandName,
      otherItem: OtherItem,
      quantity: Qunatity,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddPOD`,
        postData,
        { headers },
      );

      Swal.fire({
        icon: "success",
        title: "Form Added!",
        html: `<p>Proof of Delivery has been saved successfully.</p>`,
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });

      if (props.onFormSubmit) props.onFormSubmit(response);
      props.handleClose();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };

  return (
    <Grid
      container
      columnSpacing={1}
      style={{ color: "black", marginTop: "20px" }}
    >
      {/* ================= HEADER BANNER ================= */}
      <Grid item xs={12}>
        <Box
          sx={{
            backgroundColor: "#2F6E62",
            color: "#ffffff",
            borderRadius: 2,
            padding: "14px 20px",
            textAlign: "center",
            mb: 2,
          }}
        >
          <Typography variant="h4" fontWeight="bold" sx={{ color: "#fff" }}>
            Proof of Delivery (POD)
          </Typography>
        </Box>
      </Grid>

      {/* ================= SUBTITLE ================= */}
      <Grid item xs={12}>
        <Typography
          variant="h6"
          align="center"
          fontWeight="bold"
          sx={{ color: "#1f2937", mb: 0.5 }}
        >
          Custom Oral Appliance
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ color: "#374151", mb: 3 }}
        >
          (Receipt of DME Goods)
        </Typography>
      </Grid>

      {/* ================= INTRO PARAGRAPH ================= */}
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
            I certify that I have received the item(s) marked below in good
            condition. The equipment is medically necessary and not substandard.
            This device was custom fitted and sized and fits well. I have
            received verbal and written instructions for the use of the
            equipment, the warranty, complaint resolution and the Durable
            Medical Equipment Supplier Guidelines.
          </Typography>
        </Grid>
      </Grid>

      {/* ================= ITEM CHECKBOX + DESCRIPTION ================= */}
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid
          item
          xs={12}
          sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
        >
          {/* <Typography
            variant="body1"
            sx={{ fontWeight: 600, minWidth: 20, mt: 0.3 }}
          >
            ______
          </Typography> */}
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Custom Fabricated Oral Appliance for Obstructive Sleep Apnea (E0486)
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body1">Quantity</Typography>

            <TextField size="small" 
               value={Qunatity}
            onChange={(e) => setQunatity(e.target.value)}
            variant="standard" sx={{ width: 150 }} />
          </Box>

          <Typography variant="body1">(X) New Equipment</Typography>
        </Grid>
      </Grid>

      {/* ================= BRAND NAME + OTHER ITEM ================= */}
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" sx={{ minWidth: 220 }}>
            Brand Name (Manufacturer):
          </Typography>
          <TextField
            size="small"
            variant="standard"
            value={BrandName}
            onChange={(e) => setBrandName(e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="body1"
            sx={{ minWidth: 220, cursor: "pointer" }}
            onClick={() => setOtherItemChecked(!OtherItemChecked)}
          >
            {OtherItemChecked ? "(X)" : "______"} Other Item:
          </Typography>
          <TextField
            size="small"
            variant="standard"
            value={OtherItem}
            onChange={(e) => setOtherItem(e.target.value)}
            fullWidth
          />
        </Grid>
      </Grid>

      {/* ================= PATIENT NAME + SIGNATURE + DATE ================= */}
      <Grid
        container
        spacing={3}
        sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
      >
        {/* Patient Name */}
        <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" sx={{ minWidth: 220 }}>
            Patient name (Print):
          </Typography>
          <TextField
            size="small"
            variant="standard"
            name="printName"
            value={PrintName || props.PatientName || ""}
            onChange={(e) => setPrintName(e.target.value)}
            fullWidth
          />
        </Grid>

        {/* Signature + Date */}
        <Grid item xs={8} sx={{ mt: 2 }}>
          <TextField
            size="small"
            variant="standard"
            name="signature"
            value={Signature}
            onChange={(e) => setSignature(e.target.value)}
            fullWidth
          />
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            Patient Signature
          </Typography>
        </Grid>

        <Grid item xs={4} sx={{ mt: 2 }}>
          <TextField
            type="date"
            size="small"
            variant="standard"
            value={SignatureDate}
            onChange={(e) => setSignatureDate(e.target.value)}
            fullWidth
          />
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            Date
          </Typography>
        </Grid>
      </Grid>

      {/* ================= SUBMIT BUTTON ================= */}
      {props.callingFrom == "PatientQuestionares" && (
        <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button
            type="submit"
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            Save
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default POD;
